// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'

Vue.config.productionTip = false

let app = ''

firebase.initializeApp({
  apiKey: 'AIzaSyDvvS_lTgkGDJAVJDIHKI7V2uYAk5cKpc4',
  authDomain: 'jeu-kawaa.firebaseapp.com',
  databaseURL: 'https://jeu-kawaa.firebaseio.com',
  projectId: 'jeu-kawaa',
  storageBucket: '',
  messagingSenderId: '949832849784',
  appId: '1:949832849784:web:635b6b1d74029867'
})

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})



// WEBPACK FOOTER //
// ./src/main.js